module.exports = __webpack_public_path__ + "1.5.0-unryo/img/amazon.6a6e4350.svg";